import { RouteConfig } from 'vue-router';
import Loading from '@views/loading';
import { LoadingContext } from '@views/loading/context';
import { useLoading as useAtobaraiSettlementLoading } from '@views/loading/atobaraiSettlementLoading';
import AuthNg from '@views/fail/auth-ng';
import { AuthNgFailContext } from '@views/fail/auth-ng/composable';
import atobaraiNgFailContext from '@views/fail/auth-ng/AtobaraiAuthNgContext';
import AppEmptyRoute from '@berlin-front/common/components/elements/AppEmptyRoute';
import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';
import { ROUTE_NAME } from './route-name';

const atobaraiRoute: RouteConfig = {
  path: '/np-atobarai',
  components: {
    default: AppEmptyRoute,
  },
  children: [
    {
      // 後払いローディング画面
      // （画面上はモーダル基盤ごと透明表示するため見えない。ただし、他のAtoneと同じviewを使用しているので表示することはできるっちゃできる。）
      path: 'loading',
      name: ROUTE_NAME.NP_ATOBARAI_LOADING,
      components: {
        default: Loading,
        contextProvider: LoadingContext.provider,
      },
      props: {
        // ローディングコンテキストは差し替えで表示する。
        contextProvider: useAtobaraiSettlementLoading,
      },
    },
    {
      // 後払い決済失敗画面
      path: 'fail/auth-ng',
      name: ROUTE_NAME.NP_ATOBARAI_FAIL_AUTH_NG,
      components: {
        default: AuthNg,
        contextProvider: AuthNgFailContext.provider,
      },
      props: {
        contextProvider: atobaraiNgFailContext,
      },
      meta: {
        // 後払いは、ショップ名が出せないため何も出さない。
        headerType: HEADER_TYPE.TITLE_ONLY,
        headerTitle: '',
      },
    },
  ],
};

export default atobaraiRoute;
